export default "<div id=\"spinnerElement\" class=\"spinner-wrapper col-12\">\n  <div class=\"spinner\"></div>\n</div>\n"